import { render, staticRenderFns } from "./InterventionList.vue?vue&type=template&id=606c0c7c&scoped=true"
import script from "./InterventionList.vue?vue&type=script&lang=js"
export * from "./InterventionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c0c7c",
  null
  
)

export default component.exports